/* global $ */

import WorksContent from './WorksContent';
import WorksMV from './WorksMV';

class PageWorksDetail {
  constructor(mainApp) {
    this.$window = $(window);
    console.log('PageWorksDetail');
    this.mainApp = mainApp;

    this.worksMv = new WorksMV();
    if ($('.Content').length) {
      new WorksContent();
    }
  }
  onLoadWindow() {}
  onWindowResize() {
    this.windowH = this.$window.height();
  }
  onWindowScroll() {
    let scrollTop = this.$window.scrollTop();
    this.worksMv.update(scrollTop, this.windowH);
  }
  destroy() {}
}

export default PageWorksDetail;
